<h2 mat-dialog-title>Are you sure?</h2>
<mat-dialog-content class="mat-typography">
    <p [innerHTML]="data.question"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.yesAnswer}}</button>
    <button mat-button [mat-dialog-close]="false">{{data.noAnswer}}</button>
</mat-dialog-actions>